"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const theme_1 = require("../../theme");
const font_1 = require("../../font");
const constants_1 = require("../../../elements/course/NavButtons/constants");
const genStyle_1 = require("../genStyle");
const styleSchema = {
    show: {
        show: (0, genStyle_1.genStyle)({ value: true }),
    },
    hover: {
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.focusedColor }),
    },
    nextButton__var: {
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryColor }),
        backgroundImage: (0, genStyle_1.genStyle)({ value: null }),
        showIcons: (0, genStyle_1.genStyle)({ value: true }),
        icon: (0, genStyle_1.genStyle)({ value: null }),
        borderStyle: (0, genStyle_1.genStyle)({ value: 'none' }),
        borderColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.borderColor }),
        borderWidth: (0, genStyle_1.genStyle)({ value: 1 }),
        borderRadius: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.borderRadius }),
    },
    nextButtonDisabled__var: {
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.inactiveColor }),
        backgroundImage: (0, genStyle_1.genStyle)({ value: null }),
    },
    prevButton__var: {
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryColor }),
        backgroundImage: (0, genStyle_1.genStyle)({ value: null }),
        showIcons: (0, genStyle_1.genStyle)({ value: true }),
        icon: (0, genStyle_1.genStyle)({ value: null }),
        borderStyle: (0, genStyle_1.genStyle)({ value: 'none' }),
        borderColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.borderColor }),
        borderWidth: (0, genStyle_1.genStyle)({ value: 1 }),
        borderRadius: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.borderRadius }),
    },
    prevButtonDisabled__var: {
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.inactiveColor }),
        backgroundImage: (0, genStyle_1.genStyle)({ value: null }),
    },
    effects: {
        boxShadow: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.boxShadow }),
    },
    padding__var: {
        paddingTop: (0, genStyle_1.genStyle)({ value: 12 }),
        paddingLeft: (0, genStyle_1.genStyle)({ value: 32 }),
        gap: (0, genStyle_1.genStyle)({ value: 20 }),
    },
};
const fontSchema = {
    base: Object.assign(Object.assign({}, font_1.FONT_SCHEMA_EMPTY.base), { color: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.lightTextColor }) }),
};
exports.default = { [constants_1.TYPE]: { style: styleSchema, font: fontSchema, feedback: {} } };
